/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The current status of the storage gateway
*/
export enum StorageGatewayStatus {
  STORAGE_GATEWAY_STATUS_UNSPECIFIED = 'STORAGE_GATEWAY_STATUS_UNSPECIFIED',
  STORAGE_GATEWAY_STATUS_HEALTHY = 'STORAGE_GATEWAY_STATUS_HEALTHY',
  STORAGE_GATEWAY_STATUS_UNHEALTHY = 'STORAGE_GATEWAY_STATUS_UNHEALTHY',
  STORAGE_GATEWAY_STATUS_PENDING = 'STORAGE_GATEWAY_STATUS_PENDING'
}
